module.exports = __webpack_public_path__ + "static/media/newformaAPI.eb654026.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/newformaAPI.png
 ** module id = 1248
 ** module chunks = 0
 **/